import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-accesso',
  templateUrl: './accesso.component.html',
  styleUrls: ['./accesso.component.css']
})
export class AccessoComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit(): void {
  }

  btnCreaProfilo() {
    this.router.navigate(['/profilo/'])
  }

  btnAccedi() {
    this.router.navigate(['/login/'])
  }

  btnRecuperaPassword() {
    this.router.navigate(['/recupera-password/'])
  }

}
